import { Link } from "react-router-dom";
import { Article } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

interface ArticleCardProps {
  article: Article;
  showCategory?: boolean;
}

export default function ArticleCard({ article, showCategory = true }: ArticleCardProps) {
  const category = categories.find((c) => c.slug === article.categorySlug);

  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        {showCategory && category && (
          <Link
            to={`/category/${category.slug}`}
            className="inline-block mb-2.5 px-2.5 py-1 rounded-md text-xs font-medium bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors"
          >
            {category.name}
          </Link>
        )}
        <Link to={`/article/${article.slug}`} className="block">
          <h3 className="font-heading text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {article.summary}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
          <span>{article.date}</span>
        </div>
      </div>
    </article>
  );
}